import { render, staticRenderFns } from "./TicketMoreInfo.vue?vue&type=template&id=5aa5e1d7&scoped=true"
import script from "./TicketMoreInfo.vue?vue&type=script&lang=js"
export * from "./TicketMoreInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketMoreInfo.vue?vue&type=style&index=0&id=5aa5e1d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5e1d7",
  null
  
)

export default component.exports